













import { Vue, Prop, Component } from 'vue-property-decorator'

  @Component({
    name: 'ClassPanel'
  })
export default class extends Vue {
    @Prop({ required: true }) private title!: string
    @Prop({ required: true }) private dataArr!: Array<any>

    private labelList: Array<string> = ['最高分', '中位数', '最低分', '标准差', '平均分']
}
